
<template>
  <div :option="option">
    <el-row :gutter="15" type="flex">
        <el-col :span="6" v-for="(item,index) in option.slice(0,4)" :key="index">
            <div class="liveListBox">
                <div class="liveListBoxTitle ">
                    <p>{{item.liveName}}</p>
                </div>
                <div class="liveListBoxTips">
                    <span class="liveListBoxTipsLable">{{item.activityTypeName}}</span>
                    <span class="liveListBoxTipsTime">{{item.liveStartDate | formatDate('all')}}</span>
                </div>
                <div class="liveListBoxImg">
                  <div class="liveListMask" @click="goLive(item)">
                    <div class="liveBookTime liveListTimeBtn">{{$t('homes.bookingNow')}}</div>
                  </div>
                  <img class="liveListBoxImages" :src="item.liveImgUrl" />
                </div>
                <div class="liveListBoxComName divEllipsis">{{item.liveSponsorName}}</div>
            </div>
        </el-col>
    </el-row>
    <div class="liveListBtn" @click="goLiveList()">
        <div>{{$t('homes.viewMoreLive')}}</div>
    </div>
  </div>
</template>
<script>
import { eventMixin } from '@/mixins/event.js'
export default {
  props: {
    option: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  mixins: [eventMixin],
  data() {
    return {
      images:'',
      liveTitle:'',
      liveState:'',
      options:[],
    }
  },
  computed: {

  },
  mounted() {
      
  },
  methods: {
    goLive(item){
      // this.liveEvent(item.id)
      this.pageDetail(item, 'live', true, 'exhibitor')
    },
    goLiveList(){
      window.PC.$RangersEvent("homeexhibitor_live_morebtton_click")
      this.$router.push('/live')
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>
